import React from 'react'
import styled from 'styled-components'

const Box = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    height: 90%;
    margin-bottom: 2px;
    width: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Circle = styled.div`
    background-color: ${props => props.color || 'red'};
    border-radius: 100%;
    width: 30px;
    height: 30px;
    cursor: pointer;
`

const MobilePingButton = ({ onClick, color }) => {
    const handleClick = (e) => {
        e.stopPropagation()
        onClick()
    }
    return (
        <Box onClick={handleClick}>
            <Circle color={color} />
        </Box>
    )
}

export default MobilePingButton